export default __webpack_public_path__ + "static/media/27.c4d04385.png";